import { useTranslation } from 'react-i18next'

import { Alert } from '@enechain/ecloud-designsystem'

import { formatTimeUntilDeadline } from '~/pages/SpotBidding/models/spotBidWithdrawAction'

type Props = {
  /** 入札締切 (= 受渡日前日 10:00 JST)。 残り時間に使う。 */
  deadline: Date
  /** 残り時間の基準時刻 (= 現在時刻)。 test から固定できるよう prop で受ける。 */
  now: Date
}

/**
 * 取下の確認モーダルに出す、 札なし窓の注記 (AC-BSP-057 / AC-BSP-116)。 取消が成立してから
 * 再入札するまでの間そのコマに札が無い状態になり、 承認モードによっては再入札の承認完了までその
 * 状態が続く。 「取消したまま締切を迎えて札なしになる」 事故を防ぐ。
 *
 * 「注意が必要だがブロックはしない」 ので warning。
 */
export const WithdrawNoBidWindowNote = ({
  deadline,
  now,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <Alert
      description={t('page:biddingSpot.withdrawConfirm.noBidWindowNoteBody', {
        remaining: formatTimeUntilDeadline(now, deadline),
      })}
      status="warning"
      title={t('page:biddingSpot.withdrawConfirm.noBidWindowNoteTitle')}
    />
  )
}
